import React from "react";
import "./style.css";
const Sidebar = () => {
  const open_menu = () => {
    document.getElementById("menu-open").classList.toggle("btn-toggle");
    document.getElementById("close").classList.toggle("close-btn");
  };
  return (
    <div id="menu-open" className="sidebar">
      <div
        id="close"
        className="open-sidebar-btn"
        onClick={() => {
          open_menu();
        }}
      ></div>
      <h2>Nasf.id</h2>
      <ul className="menu">
        <li className="list">
          Dashboard <i className="list_icon material-icons">dashboard</i>
        </li>
        <li className="list">
          Bank Saal
          <i className="list_icon material-icons">edite</i>
        </li>
        <li className="list active">
          Penjualan
          <i className="list_icon material-icons">paid</i>
        </li>
        <li className="list">
          Media Belajar<i className="list_icon material-icons">school</i>
        </li>
        <li className="list">
          Informasi<i className="list_icon material-icons">newspaper</i>
        </li>
        <li className="list">
          Test Toefi <i className="list_icon material-icons">content_copy</i>
        </li>
        <li className="list">
          Sertifikasi<i className="list_icon material-icons">local_police</i>
        </li>
        <li className="line"></li>
        <li className="list">
          Komplain & Saran
          <i className="list_icon material-icons">maps_ugc</i>
        </li>
        <li className="list">
          Forum Diskusi<i className="list_icon material-icons">forum</i>
        </li>
        <li className="list">
          Pengaturan<i className="list_icon material-icons">settings</i>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
